module.exports = __webpack_public_path__ + "media/images/specialty_icons/home_specialty_neurosurgery-cd7145917513517627c385a54efbf47d.png";